import './TopContainer.css';
import { IoIosArrowDown } from "react-icons/io";
import { FaSearch, FaPlus } from "react-icons/fa";
import { Link } from 'react-router-dom';
import { useContext } from 'react';
import { TicketFilterContext } from '../../context/TicketFilterContext';
import NotifyUtils from '../../utils/NotifyUtils';
import { verificaTipoFiltro } from '../../utils/ChamadoUtils';
import { useTranslation } from 'react-i18next';


function TopContainer() {
    const { t } = useTranslation();

    const { ticketFilter, handleChange, handleSearch, setTipoFiltro, setTicketFilter } = useContext(TicketFilterContext);

    const naoDisponivel = (event) => {
        event.preventDefault();
         NotifyUtils.custom(t("em-desenvolvimento"));
    }

    const handleSearchCustom = () => {
        setTipoFiltro(verificaTipoFiltro(ticketFilter));
    
        handleSearch();
        NotifyUtils.sucesso(t("pesquisa-sucesso")); 
    };
    

    return (
        <div className="top-container">
            <div className="header-top-container">
                <div className="textos-header-top-container">
                    <h3>{t("selecione-filtros")}</h3>
                    <p onClick={(e) => {naoDisponivel(e)}} className="botao-filtros-avancados-top-container">{t('filtro-avancado')} <IoIosArrowDown /></p>
                </div>
                <hr className="divisor-top-container" />
            </div>
            <div className="filtro-top-container">
                <label htmlFor="pesquisa-contem" className="pesquisa-contem-label">
                    <FaSearch className="icone-pesquisa-top-container" />{t('contem-texto')}</label>
                <div className="div-abaixo-top-container">
                    <div className="pesquisa-simples-top-container">
                        <input
                            type="text" className="pesquisa-contem" placeholder= {t('campo-pesquisa')}
                            onChange={(e) => { handleChange(e.target.value) }}
                            value={ticketFilter}
                        />
                    </div>
                    <div className="botoes-top-container">
                        <button className="botao-pesquisar-top-container" onClick={handleSearchCustom}>{t('botao-pesquisar')} <FaSearch /></button>
                        <Link className="link abrir-chamado" to="/abrir-chamado">
                            <button className="botao-novo-chamado-top-container novo-chamado">{t('botao-novo-chamado')} <FaPlus /></button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TopContainer;
